/**
 * EmptyHomeHint — a soft arrow + sentence that appears under the
 * three action cards when the user has zero proofs. Points up at
 * the action cards and bobs gently to draw the eye.
 *
 * Per [docs/DASHBOARD-HOME-EXPLORE-IMPLEMENTATION.md §2.5]. The
 * `gi-bob` keyframe lives in `ui/src/styles/globals.css`; the
 * global `prefers-reduced-motion` reset there nukes its duration
 * to ~0ms for users who opt out, so the inline-style strip below
 * is a belt-and-braces for browsers that miss the global reset.
 */

import { useTranslation } from 'react-i18next';
import { motion, useReducedMotion } from 'framer-motion';
import { ArrowUp } from 'lucide-react';

import { arrive } from '@/lib/motion';

export function EmptyHomeHint() {
  const { t } = useTranslation('dashboard');
  const reduce = useReducedMotion();

  return (
    <motion.section
      aria-labelledby="empty-hint-heading"
      className="mt-10 flex flex-col items-center text-center"
      {...(reduce ? {} : { variants: arrive, initial: 'hidden', animate: 'visible' })}
    >
      <ArrowUp
        className="h-6 w-6 text-spark"
        aria-hidden
        // Subtle bobbing animation. ~3s per cycle.
        {...(reduce
          ? {}
          : { style: { animation: 'gi-bob 3s ease-in-out infinite' } })}
      />
      <p
        id="empty-hint-heading"
        className="mt-2 max-w-md text-sm text-ink-muted"
      >
        {t('empty.home_hint')}
      </p>
    </motion.section>
  );
}
